export default __webpack_public_path__ + "static/media/tc.e4a16767.svg";